<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<path
		d="M12 17C11.45 17 11 16.55 11 16L11 12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12L13 16C13 16.55 12.55 17 12 17ZM12.01 22C17.53 22 22 17.52 22 12C22 6.48 17.53 2 12.01 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12.01 22ZM12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4ZM11 7L13 7L13 9L11 9L11 7Z"
		fill="currentColor"
	/>
</svg>
